import { makeStyles, Theme } from '@material-ui/core';
import { Colors, Typography } from '../../../shared/theme/styles.enum';

interface StyleProps {
  isComplexProduct?: boolean;
  expanded?: boolean;
}

export const useStyles = makeStyles<Theme, StyleProps>(({ palette }) => ({
  container: {
    width: '95.6%',
    margin: '0px auto 40px auto',
    display: 'flex',
    '@media (max-width:768px)': {
      width: '100%',
      margin: '0px auto 20px auto',
      padding: '0 8px',
      boxSizing: 'border-box' as const,
    },
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100px',
  },
  accordion: {
    width: '100%',
    borderLeft: '4px solid',
    borderLeftColor: palette.primary.main,
    borderRadius: '10px !important',
    paddingTop: 5,
    paddingBottom: 4,
    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.08) !important',
    cursor: 'auto',
    transition: 'box-shadow 0.2s ease, transform 0.2s ease !important',
    '&:hover': {
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.12) !important',
      transform: 'translateY(-1px)',
    },
    '& .MuiAccordionSummary-root.Mui-expanded': {
      minHeight: '90px',
    },
  },
  accordionSummary: {
    padding: 0,
    boxShadow: (props) =>
      props.expanded ? '' : `0px 10px 5px -3px ${Colors.TableHover}`,
  },
  mainGrid: {
    flexGrow: 1,
    alignItems: 'center',
    '@media (max-width:768px)': {
      padding: '8px 0',
    },
  },
  hyba: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  data: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
  },
  productName: {
    display: 'flex',
    alignItems: 'center',
  },
  apyContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  apyTitle: {
    fontSize: Typography.BasicText,
    fontFamily: Typography.FontFamily2,
    fontWeight: 600,
    lineHeight: 1.2,
    display: 'flex',
    justifyContent: 'center',
    '& span': {
      fontWeight: 500,
    },
    '@media (max-width:768px)': {
      fontSize: '0.85rem',
      justifyContent: 'flex-start',
      marginLeft: 12,
      marginTop: 4,
    },
  },
  totalTitle: {
    fontSize: Typography.BasicText,
    fontFamily: Typography.FontFamily2,
    fontWeight: 500,
    lineHeight: 1.2,
    textAlign: 'right',
    marginRight: 30,
    '& span': {
      fontWeight: 500,
    },
    '@media (max-width:768px)': {
      fontSize: '0.85rem',
      marginRight: 12,
      textAlign: 'right',
      marginTop: 4,
    },
  },
  amount: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 33,
  },
  productIcon: {
    marginLeft: 20,
    width: 44,
    height: 44,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '@media (max-width:768px)': {
      marginLeft: 8,
      width: 30,
      height: 30,
    },
  },
  heading: {
    fontFamily: Typography.FontFamily2,
    fontSize: '1.5rem',
    fontWeight: 600,
    color: Colors.Black,
    textAlign: 'left',
    marginLeft: 5,
    '@media (max-width:768px)': {
      fontSize: '0.9rem',
      marginLeft: 0,
      lineHeight: 1.3,
    },
  },
  secondaryHeading: {
    fontFamily: Typography.FontFamily2,
    fontSize: '2.125rem',
    lineHeight: '1.5rem',
    color: Colors.Black,
    textAlign: 'right',
    marginRight: 30,
    '& span': {
      fontSize: '1.5rem',
      fontFamily: Typography.FontFamily2,
      lineHeight: '1.5rem',
      color: Colors.Black,
      justifySelf: 'end',
      alignSelf: 'center',
    },
  },
  total: {
    fontSize: '1.25rem !important',
    '@media (max-width:768px)': {
      fontSize: '0.85rem !important',
    },
  },
  details: {
    borderTop: '1px solid',
    borderTopColor: Colors.TableHover,
    zIndex: 0,
  },
  product: {
    marginTop: 20,
  },
  gridContainer: {
    padding: '5rem 2.5rem 0 2.5rem',
    '@media (max-width:768px)': {
      padding: '1.5rem 1rem 0 1rem',
    },
  },
  hybaContainer: {
    '&::before': {
      content: '""',
      display: 'block',
      height: 1,
      width: '100%',
      background: Colors.TableHover,
      margin: '1rem auto',
    },
  },
  hybaWrapper: {
    padding: '0px 30px',
  },
  grid: {
    flexGrow: 1,
    padding: '30px 0px',
  },
  header: {
    fontFamily: Typography.FontFamily2,
    fontSize: Typography.BasicText,
    fontWeight: 600,
    lineHeight: 1.2,
  },
  name: {
    fontFamily: Typography.FontFamily2,
    fontSize: Typography.BasicText,
    fontWeight: 500,
    textAlign: 'left',
  },
  apy: {
    fontFamily: Typography.FontFamily2,
    fontSize: Typography.BasicText,
    fontWeight: 500,
    textAlign: 'left',
  },
  line: {
    width: '90%',
    border: 'none',
    alignItems: 'center',
    borderTop: `1px dotted ${Colors.TextGray}`,
    marginTop: 15,
    marginRight: 50,
  },
  totalAmount: {
    display: 'flex',
    fontFamily: Typography.FontFamily2,
    fontSize: Typography.BasicText,
    fontWeight: 400,
    textAlign: 'right',
    paddingBottom: 5,
  },
  depositButton: {
    fontFamily: Typography.FontFamily2,
    fontSize: Typography.Body,
    fontWeight: 600,
    color: palette.primary.main,
    borderRadius: 6,
    border: '1px solid',
    borderColor: palette.primary.main,
    textTransform: 'none',
    width: 154,
    height: 36,
    justifySelf: 'end',
    alignSelf: 'center',
    marginRight: 0,
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: 'rgba(63,167,149,0.05)',
    },
  },
  hybaTotal: {
    fontFamily: Typography.FontFamily2,
    fontSize: Typography.BasicText,
    fontWeight: 500,
    whiteSpace: 'nowrap',
  },
  hybaAmount: {
    fontFamily: Typography.FontFamily2,
    fontSize: Typography.H3,
    fontWeight: 400,
    lineHeight: 0.86,
  },
  hybaDecimals: {
    fontSize: '1.3rem',
  },

  //TABS
  containerStyle: {
    '& .Mui-selected': {
      color: palette.primary.main,
      fontWeight: 'bold',
    },
    '& .MuiTab-root': {
      minWidth: 'fit-content',
    },
  },
  tabsRowStyle: {
    marginTop: 0,
    borderBottom: `1px solid ${Colors.BorderAndBG}`,
    paddingBottom: 0.2,
  },
  childrenStyle: {
    padding: '2.8rem 0 0 0',
  },
}));
